import React, { FC } from "react";
import { Modal, Button } from 'antd';
import { useCardModel } from "../cardModel";

export const SyncModal = () => {
    const { syncVisible: visible, setSyncVisible, sync } = useCardModel(({ syncVisible }) => [syncVisible])

    const onCancel = () => {
        setSyncVisible(false);
    };

    return <Modal
        visible={visible}
        title="人员同步"
        onOk={() => { }}
        onCancel={onCancel}
        footer={[
            <Button key="submit" onClick={() => { sync() }}> 是</Button>,
            <Button key="back" type="primary" onClick={() => { }}>
                只更新新增
            </Button>,
            <Button
                key="link"
                type="primary"
                onClick={() => { }}
            >
                只删除禁用
            </Button>,
        ]}
    >
        <p>新增人员包括：...</p>
        <p>禁用人员包括：...</p>
        <p>是否同步更新新增人员并删除禁用人员？</p>
    </Modal>
}
